import React from 'react';
import classNames from 'classnames';
import classes from './styles.module.scss';

export default function PagindateItems({ itemId, itemIds, setCurrentItemId }) {
  const currentItemIndex = itemIds?.findIndex((item) => item === itemId);

  const getPrevCandidate = () => {
    if (!itemIds[currentItemIndex - 1]) {
      return;
    }

    setCurrentItemId(itemIds[currentItemIndex - 1]);
  };

  const getNextCandidate = () => {
    if (!itemIds[currentItemIndex + 1]) {
      return;
    }

    setCurrentItemId(itemIds[currentItemIndex + 1]);
  };

  return (
    <div className={classes.pagination}>
      <div
        className={classNames(classes.prev, {
          [classes.active]: itemIds?.[currentItemIndex - 1],
        })}
        onClick={getPrevCandidate}
      />
      <div
        className={classNames(classes.next, {
          [classes.active]: itemIds?.[currentItemIndex + 1],
        })}
        onClick={getNextCandidate}
      />
    </div>
  );
}
